import Header from './components/Header/Header'
import Main from './components/Main/Main'
import Projects from './components/Projects/Projects'
import Footer from './components/Footer/Footer'
// @ts-ignore: CSS module import without type declarations
import './styles/App.css'

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Main />
        <Projects />
      </main>
      <Footer />
    </div>
  )
}

export default App